package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.CheckW500Rounded: ImageVector
    get() {
        if (_checkW500Rounded != null) {
            return _checkW500Rounded!!
        }
        _checkW500Rounded = Builder(name = "CheckW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(382.0f, 597.87f)
                lineToRelative(334.7f, -334.7f)
                quadToRelative(13.67f, -13.67f, 32.06f, -13.67f)
                reflectiveQuadToRelative(32.07f, 13.67f)
                quadToRelative(13.67f, 13.68f, 13.67f, 32.45f)
                quadToRelative(0.0f, 18.77f, -13.67f, 32.45f)
                lineTo(414.07f, 695.59f)
                quadToRelative(-13.68f, 13.67f, -32.07f, 13.67f)
                reflectiveQuadToRelative(-32.07f, -13.67f)
                lineTo(178.41f, 524.07f)
                quadToRelative(-13.67f, -13.68f, -13.29f, -32.45f)
                quadToRelative(0.38f, -18.77f, 14.05f, -32.45f)
                quadToRelative(13.68f, -13.67f, 32.45f, -13.67f)
                quadToRelative(18.77f, 0.0f, 32.45f, 13.67f)
                lineTo(382.0f, 597.87f)
                close()
            }
        }
        .build()
        return _checkW500Rounded!!
    }

private var _checkW500Rounded: ImageVector? = null
